/*****************************************************
Naam: DashboardClock.jsx
Locatie: src/components/Dashboard/DashboardClock.jsx
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Klok component met tijd en datum display.
******************************************************/

import React, { useState, useEffect } from 'react';
import { formatTime, formatDate } from './utils/dashboardHelpers';

const DashboardClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="text-center">
      <div className="text-6xl font-bold text-white mb-1 tracking-wider">
        {formatTime(currentTime)}
      </div>
      <div className="text-lg text-white/80">
        {formatDate(currentTime)}
      </div>
    </div>
  );
};

export default DashboardClock;
